<template>
    <div></div>
</template>

<script setup>
    import {  onMounted} from 'vue'
    import { useSystemStore } from '@/stores/system'
    const systemStore = useSystemStore()

    onMounted(()=> {

        systemStore.showMessage('User Redirected', {color: 'info'})
        var url = "https://apj.dellpartnerincentives.com"
        // var url = 'http://theincentivecompany.org/'

        window.open(url, '_blank').focus();
        
        
    })
</script>

